import AbstractChart from './abstract-chart.js';


export default class TableChart extends AbstractChart 
{

	constructor(params) 
	{	
		super(params);

		this.params.type = 'table';
	}
	

	createVisualization() 
	{
		return new google.visualization.Table(document.getElementById(this.params.id));
	}

}